import React, { useMemo, useRef } from 'react';

// Classname
import clsx from 'clsx';

// components
import Button from 'components/UiKit/Button';
import FieldText from 'components/UiKit/FieldText';
import FieldSelect from 'components/UiKit/FieldSelect';
import FieldCheckbox from 'components/UiKit/FieldCheckbox';

// Lib
import { useWindowSize } from 'lib/hooks';
import { shallowEqual } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'lib/hooks/useDispatch';
import { convertedToArray, convertProjectsToOptions } from 'lib/helpers';

// Actions
import { openModal } from 'reducers/modal';
import { showMessage } from 'reducers/messages';
import * as actionsCreator from 'pages/ChemicalProbes/reducer';
import * as actionsCreatorProject from 'pages/Projects/reducer';
import { handlerChangePriceApp, toggleModal } from 'reducers/settings';

// Constants
import { styleFieldSelectTarActions } from 'constans/search';

// Constants
import {
	styleFieldSelectAccessibility,
	styleFieldSelectPrices,
	styleFieldSelectProject
} from 'pages/LibrariesCompounds/components/HeaderList';

const optionsAccessibility = [
	{ label: 'All', value: '' },
	{ label: 'In stock', value: 'ON_STOCK' },
	{ label: 'Out of stock', value: 'OUT_OF_STOCK' }
];

// Interface
interface IHeaderList {
	isModal?: boolean;
	className?: string;
}

// Type
type TFuncArgs = {
	[index: string]: string | number;
}

export const HeaderList: React.FC<IHeaderList> = (props) => {
	const { className = '', isModal = false } = props;

	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const ref: any = useRef(null);

	const {
		user,
		currentPrice,
		dataProjects,
		currentProject,

		px,
		data,
		dataOld,
		tAction,
		checkboxAll,
		optionsAction,
		accessibility
	} = useAppSelector(
		(store) => {
			return {
				dataProjects: store.projects.dataProjects,

				user: store.settings.user,
				currentPrice: store.settings.currentPrice,
				currentProject: store.projects.currentProject,

				px: store.chemicalProbes.px,
				data: store.chemicalProbes.data,
				dataOld: store.chemicalProbes.dataOld,
				tAction: store.chemicalProbes.tAction,
				checkboxAll: store.chemicalProbes.checkboxAll,
				optionsAction: store.chemicalProbes.optionsAction,
				accessibility: store.chemicalProbes.accessibility
			};
		},
		shallowEqual
	);

	const countSelectedItems = data?.filter(
		(item: any) => item.selected
	)?.length;
	const disabledAddProject = !!countSelectedItems;
	const convertedProjects = convertedToArray(dataProjects);
	const prices = data?.length ? data[0]?.prices[0].prices : [];
	const optionsProjects = convertProjectsToOptions(dataProjects);

	const options: any = prices?.length
		? prices?.map(
			(item: any) => {
				return {
					type: 'Usd',
					label: `${item.mg}mg`,
					mg: item.mg ? item.mg : null,
					value: item.mg ? `price${item.mg}mg` : '',
					price: item?.priceUsd ? item?.priceUsd : 'POA'
				};
			}
		)
		: [];

	const findElement = useMemo(() => {
		return optionsProjects?.find(
			(item: TFuncArgs) => item.value === +currentProject
		);
	}, [optionsProjects, currentProject]);

	const projectValue = user?.authorized
		? findElement : [];

	const filteredDataByType = (args: { type: string }) => (item: any) => {
		const { type } = args;

		if (type === 'selected') {
			return item.selected;
		}
	};

	const handlerChangeCheckboxAll = () => {
		dispatch(actionsCreator.handlerCheckboxAll());
	};

	const handlerChangeAccessibility = (opt: { [index: string]: string }) => {
		dispatch(actionsCreator.handlerChangeAccessibility(opt));
	};

	const handlerClearAllCheckboxSelected = () => {
		dispatch(actionsCreator.handlerClearAllCheckboxSelected());
	};

	const handlerChangeTarPx = (e: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(actionsCreator.handlerChangePx(e.target.value));
	};

	const handlerChangeTarAction = (opt: TFuncArgs) => {
		dispatch(actionsCreator.handlerChangeTarAction(opt));
	};

	const handlerClearPriceAll = () => {
		ref.current.setValue([]);
		dispatch(handlerChangePriceApp([]));
		dispatch(actionsCreator.clearPricesAllData());
	};

	const handlerConfirmClearPrice = () => {
		dispatch(openModal(
			{
				color: 'error',
				type: 'confirm',
				textClose: 'Cancel',
				textSubmit: 'Confirm',
				actionSubmit: handlerClearPriceAll,
				innerClass: 'libraries-compounds__confirm',
				text: `The default prepackage size of all compounds will be set to manual selection.`
			})
		);
	};

	const handlerChangePrices = (selected: TFuncArgs) => {
		dispatch(handlerChangePriceApp(selected));
		dispatch(actionsCreator.updatePricesAll(selected));
	};

	const handlerConfirmChangePrice = (selected: TFuncArgs) => {
		dispatch(openModal(
			{
				data: selected,
				color: 'error',
				type: 'confirm',
				textClose: 'Cancel',
				textSubmit: 'Confirm',
				actionSubmit: handlerChangePrices,
				innerClass: 'libraries-compounds__confirm',
				text: `The default prepackage size of all compounds will be set to ${selected.mg} mg`
			})
		);
	};

	const handlerChangeProject = (selected: TFuncArgs) => {
		dispatch(
			actionsCreatorProject.handlerChangeCurrentProject(selected.value)
		);
	};

	const handlerAddToProject = () => {
		if (!user.authorized) {
			dispatch(toggleModal(true));
			return;
		}

		const uniqId = crypto.randomUUID();
		let result: any = [];

		for (const item of data || []) {
			const hasPrices = Object.values(item?.currentPrice)
				.filter(Boolean)
				.length;

			if (
				item.selected &&
				!hasPrices
			) {
				dispatch(showMessage({
					type: 'info',
					uniqId: uniqId,
					text: 'Choose price/mg'
				}));
				result = [];
				break;
			}

			if (
				item.selected &&
				hasPrices
			) result.push(item);
		}

		const newData = result.map((item: any) => {
			const supIds = item.supIds;
			const findElement = data?.find((elem: any) => elem?.id === item?.id);
			const prices = findElement.prices;
			const currentTypePrice = findElement.currentTypePrice;
			const findTypePrice = prices && prices.find(
				(x: any) => x.supplier === currentTypePrice
			) ? currentTypePrice : prices && prices[0]?.supplier;
			const findProductId = supIds?.find(
				(item: any) => item.supplier === currentTypePrice
			);

			return {
				...item,
				id: findProductId?.supId || '',
				supplier: findTypePrice
			};
		});

		if (currentProject && newData?.length) {
			dispatch(actionsCreatorProject.addItemToProject({
				data: newData,
				uniqId: uniqId,
				url: '/projects',
				id: currentProject,
				title: 'Compound Added to project',
				text: 'Review or continue browsing. Contact<br/> us for any questions. Thank you!'
			}));
			return;
		}

		const itemsWithValidPrice = newData.filter(
			(item: any) => item.currentPrice && item.currentPrice.mg
		);

		if (!currentProject && itemsWithValidPrice.length) {
			const modalConfig = {
				data: newData,
				url: '/projects',
				navigate: navigate,
				isAddItem: 'isAddItem',
				title: 'Compound Added to project',
				type: convertedProjects.length ? 'projectsList' : 'projectAdd',
				text: 'Review or continue browsing. Contact<br/> us for any questions. Thank you!'
			};

			dispatch(openModal(modalConfig));
		}
	};

	const isAvailabilityValid = (value: string) => {
		return value !== 'OUT_OF_STOCK';
	};

	const handleChangeToggleFilter = () => {
		dispatch(actionsCreator.changeToggleFilter());
	};

	const { width } = useWindowSize();
	const isDesktop = width <= 1024;
	const filteredElement = data.filter(filteredDataByType({ type: 'selected' }));
	const labelAddSelected = `Add ${filteredElement.length} selected`;

	const cn = clsx(
		'chemical-probes__header-list',
		className ? className : ''
	);

	const icon = isModal
		? 'crossSvg'
		: 'filterSvg';

	return (
		<div className={cn}>
			<div
				className="chemical-probes__wrapper-header-list mb50 flex flex-ai-end flex-jc-between flex-direction-column-desktop">
				<div className="chemical-probes__wrapper-header-list-left flex flex-ai-end flex-jc-between">
					{isDesktop && isAvailabilityValid(accessibility?.value || '') && <FieldCheckbox
						label="Select all"
						value={checkboxAll}
						name="checkboxItemAll"
						onChange={handlerChangeCheckboxAll}
						classNameLabel="libraries-compounds__checkbox-all"
						className="chemical-probes__field-checkbox-all ml10"
					/>}

					<p className="chemical-probes__filters-text">Filters</p>

					<div
						className="chemical-probes__selected-block libraries-compounds__selected-block flex flex-direction-column flex-jc-between">
						<p className="chemical-probes__selected-title libraries-compounds__prices-list-all mb10">Selected</p>
						<p className="libraries-compounds__text-of flex flex-ai-center">
							{filteredElement.length} of {data?.length} <Button
							isSvg
							variable="icon"
							color="error"
							icon="deleteSvg"
							title="Clear checkbox all"
							disabled={!disabledAddProject}
							onPress={handlerClearAllCheckboxSelected}
							className="chemical-probes__selected-delete ml10"
						/>
						</p>
					</div>

					<Button
						isSvg
						icon={icon}
						title="Filter"
						variable="icon"
						onPress={handleChangeToggleFilter}
						className="chemical-probes__header-select-icon display-block-mobile ml10"
					/>
				</div>

				<div className="flex flex-ai-end flex-jc-between chemical-probes__wrapper-filters" id="chemical-probes-filter">
					<FieldText
						value={px}
						step="0.1"
						name="tarPx"
						label="pX ≥"
						innerTypeInput="number"
						style={{ width: '6rem' }}
						onChange={handlerChangeTarPx}
						className="chemical-probes__field-tar-px field-select__custom-label"
					/>

					<FieldSelect
						value={tAction}
						name="tarAction"
						label="Target action"
						options={optionsAction}
						onChange={handlerChangeTarAction}
						styles={styleFieldSelectTarActions}
						className="chemical-probes__field-tar-action"
						classNameLabel="libraries-compounds__prices-list-all"
					/>

					<FieldSelect
						required
						customRef={ref}
						name="accessibility"
						value={accessibility}
						label="Accessibility"
						options={optionsAccessibility}
						onChange={handlerChangeAccessibility}
						styles={styleFieldSelectAccessibility}
						className="chemical-probes__field-accessibility"
						classNameLabel="libraries-compounds__prices-list-all"
					/>

					<div className="chemical-probes__wrapper-prepackage flex flex-ai-end flex-jc-between">
						<FieldSelect
							required
							customRef={ref}
							options={options}
							name="pricesListAll"
							value={currentPrice}
							placeholder="Prepack"
							label="Default prepackage"
							styles={styleFieldSelectPrices}
							onChange={(value: TFuncArgs, opt: TFuncArgs) => {
								if (opt.action === 'select-option') {
									handlerConfirmChangePrice(value);
								}
							}}
							title="Prepackage for seleted compounds"
							className="chemical-probes__field-prepackage"
							classNameLabel="libraries-compounds__prices-list-all"
						/>

						<Button
							isSvg
							variable="icon"
							color="error"
							icon="deleteSvg"
							title="Clear prepackage all"
							onPress={handlerConfirmClearPrice}
							disabled={!(!!Object.values(currentPrice)?.length)}
							className="chemical-probes__btn-clear-prepackage ml10 align-self-end"
						/>
					</div>
				</div>

				<div className="chemical-probes__wrapper-header-list-right flex flex-ai-end flex-jc-between"
						 id="chemical-probes-project">
					<FieldSelect
						name="projectName"
						value={projectValue}
						options={optionsProjects}
						disabled={!user.authorized}
						placeholder="Last project name"
						onChange={handlerChangeProject}
						styles={styleFieldSelectProject}
						className="chemical-probes__field-project-name align-self-end pb5"
					/>

					<Button
						variable="info"
						label={labelAddSelected}
						onPress={handlerAddToProject}
						disabled={!disabledAddProject}
						className="chemical-probes__btn-add-project ml10 align-self-end mb5"
					/>
				</div>
			</div>

			<div className="relative flex flex-ai-center flex-jc-start libraries-compounds__border pb10">
				{isAvailabilityValid(accessibility?.value || '') && <FieldCheckbox
					className="ml10"
					label="Select all"
					value={checkboxAll}
					name="checkboxItemAll"
					onChange={handlerChangeCheckboxAll}
					classNameLabel="libraries-compounds__checkbox-all"
				/>}

				<p className="projects__description projects__sub-header-text projects__sub-header-left">Description</p>
				<div className="projects__sub-header-right projects__sub-header-text flex flex-ai-center">
					<p className="projects__sub-header-text projects__text-accessibility">Accessibility</p>
					<p className="projects__sub-header-text projects__text-price">Price</p>
					<p className="projects__sub-header-text projects__text-quantity">Quantity</p>
				</div>
			</div>
		</div>
	);
};

export default HeaderList;
